import { ResponseProps as ProductProps } from "~/api/products/retrieve";
import LanguageMenu from "~/theme/components/LanguageMenu";
import SupportButton from "~/theme/components/SupportButton";

import { ProductLogo } from "./ProductLogo";

export interface HeaderProps {
  product: ProductProps;
}

const Header: ComponentWithoutChildren<HeaderProps> = ({ product }) => (
  <div className="flex items-center justify-between py-4 px-5 w-full max-w-[1320px] mx-auto relative z-50 text-basic-white-50 min-h-14">
    <div className="pl-3">
      <ProductLogo product={product} />
    </div>

    <div className="flex items-center gap-2 text-basic-white-50">
      <div className="hidden md:block">
        <SupportButton />
      </div>

      <LanguageMenu isTransparent={true} />
    </div>
  </div>
);

export default Header;
